import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms a string identifier for a bookmaker, into a string representing a valid CSS colour
 * which is to be used as a background on elements styled in the branding of that bookmaker.
 */
@Pipe({
  name: 'bookBackgroundColour'
})
export class BookBackgroundColourPipe implements PipeTransform {

  /**
   * A pipe which transforms a string identifier for a bookmaker, into a string representing a valid CSS colour
   * which is to be used as a background on elements styled in the branding of that bookmaker.
   * @param bookName the identifier code for the bookmaker object, as returned by the sport data APIs
   * @returns a colour string for the preferred background colour matching this bookmaker (either a named colour or
   * a hex string preceded by a `"#"`), or `"initial"` if the identifier does not match one of the recognised identifiers
   */
  transform(bookName: string): string {
    switch (bookName?.toLowerCase()) {
      case "betstreet":
        return "#1392fd";
      case "fanduel":
        return "#0078ff";
      case "sugarhouse":
        return "#286193";
      case "pointsbet":
      case "pointsbet_au":
        return "#040707";
      case "william_hill":
        return "#173432";
      case "draftkings":
        return "#5eb700";
      case "wynn":
        return "#ba8a03";
      case "betmgm":
        return "#c0a971";
      case "bet_rivers_in":
      case "bet_rivers_va":
      case "bet_rivers_co":
        return "#ffb612";
      case "bet365":
      case "bet_365":
        return "#14805e";
      case "betway":
        return "#17a730";
      case "unibet":
        return "#1c7a47";
      case "tipico":
        return "#282b30";
      case "twinspires":
        return "#248ff1";
      case "bluebet":
        return "#0788c3";
      case "topsport":
        return "#0008B8";
      case "betfair":
        return "#feb809";
      default:
        return "rgb(var(--highlight))";
    }
  }

}
